import React from 'react';
import SemestresCatalog from '../Components/Catalogos/Semestres/SemestresCatalog';

export default function SemestresPage() {
    return (
        <div style={{ padding: '20px' }}>
            <SemestresCatalog />
        </div>
    );
}
